exports.post = {
    path: '/login',
    name: 'login', 
    component: () => import("@/views/main/Login.vue")
}